<ngx-loading [show]="loading"></ngx-loading>
<div [ngStyle]="{ height: 'calc(100dvh - 75px)' }">
  <button class="btn medium em-btn em-btn-green m-2" type="button" (click)="checkCardBalance()">Check Balance</button>
  <kendo-grid
    class="emr-kendo-grid hide-default-sort"
    [data]="gridView"
    [pageSize]="50"
    [pageable]="true"
    [sortable]="true"
    [sort]="sort"
    (sortChange)="sortChange($event)"
    [selectable]="true"
    [style.height.%]="100"
  >
    <ng-template kendoGridToolbarTemplate>
      <div class="flex-fill grey-two-background px-4 py-3 m-1">
        <div>
          <h5>Loads: &nbsp;&nbsp; {{ clinicCards?.loads | currency }}</h5>
          <h6 class="small">Last 30 Days</h6>
        </div>
      </div>
      <div class="flex-fill grey-two-background px-4 py-3 m-1">
        <div>
          <h5>Redemptions: &nbsp;&nbsp; {{ clinicCards?.redemptions | currency }}</h5>
          <h6 class="small">Last 30 Days</h6>
        </div>
      </div>
      <div class="flex-fill grey-two-background px-4 py-3 m-1">
        <div>
          <h5>Outstanding: &nbsp;&nbsp; {{ clinicCards?.outstanding | currency }}</h5>
          <h6 class="small">Total</h6>
        </div>
      </div>
    </ng-template>
    <kendo-grid-column title="Gift CardID" [width]="175">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="font-family-monospace">{{ getDisplayId(dataItem) }}</span>
        <i
          class="fal float-right"
          [ngClass]="isFullIdVisible(dataItem) ? 'fa-eye-slash' : 'fa-eye'"
          (click)="toggleFullId(dataItem)"
          style="cursor: pointer"
          [title]="isFullIdVisible(dataItem) ? 'Hide full ID' : 'Show full ID'"
        ></i>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Purchaser" field="purchaserName" [width]="185">
      <ng-template kendoGridHeaderTemplate let-column>
        {{ column.title }}
        <i class="ml-1" [ngClass]="sortIconClass(column)"></i>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Recipient" field="recipientName" [width]="185">
      <ng-template kendoGridHeaderTemplate let-column>
        {{ column.title }}
        <i class="ml-1" [ngClass]="sortIconClass(column)"></i>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Invoice" field="invoiceId" [width]="88">
      <ng-template kendoGridHeaderTemplate let-column>
        {{ column.title }}
        <i class="ml-1" [ngClass]="sortIconClass(column)"></i>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Purchase Date" field="purchaseDate" [width]="160">
      <ng-template kendoGridHeaderTemplate let-column>
        {{ column.title }}
        <i class="ml-1" [ngClass]="sortIconClass(column)"></i>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.purchaseDate | date : 'yyyy-MM-dd h:mm a' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Delivery Date" field="sendDate" [width]="160">
      <ng-template kendoGridHeaderTemplate let-column>
        {{ column.title }}
        <i class="ml-1" [ngClass]="sortIconClass(column)"></i>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.sendDate ? (dataItem.sendDate | date : 'yyyy-MM-dd h:mm a') : 'N/A' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Delivery Method" field="deliveryMethod" [width]="150">
      <ng-template kendoGridHeaderTemplate let-column>
        {{ column.title }}
        <i class="ml-1" [ngClass]="sortIconClass(column)"></i>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ getDeliveryMethodLabel(dataItem.deliveryMethod) }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Delivery Status" field="deliveryStatus" [width]="140">
      <ng-template kendoGridHeaderTemplate let-column>
        {{ column.title }}
        <i class="ml-1" [ngClass]="sortIconClass(column)"></i>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [ngClass]="getDeliveryStatusClass(dataItem.deliveryStatus)">
          {{ getDeliveryStatusLabel(dataItem.deliveryStatus) }}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Balance" field="balance" [width]="140">
      <ng-template kendoGridHeaderTemplate let-column>
        {{ column.title }}
        <i class="ml-1" [ngClass]="sortIconClass(column)"></i>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.balance | currency }}
      </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridDetailTemplate let-dataItem>
      <div class="container-fluid py-3">
        <div class="row">
          <div class="col-2">
            <h6 class="font-weight-bold mb-3">Purchaser Details</h6>
            <div class="mb-2" *ngIf="dataItem.purchaserData">
              <div class="d-flex align-items-center mb-2">
                <i class="fal fa-user mr-2 text-muted"></i>
                <strong class="mr-2">Name:</strong>
                <span>{{ dataItem.purchaserData.fullName }}</span>
              </div>
              <div class="d-flex align-items-center mb-2" *ngIf="dataItem.purchaserData.email">
                <i class="fal fa-envelope mr-2 text-muted"></i>
                <strong class="mr-2">Email:</strong>
                <a [href]="'mailto:' + dataItem.purchaserData.email">{{ dataItem.purchaserData.email }}</a>
              </div>
              <div class="d-flex align-items-center mb-2" *ngIf="dataItem.purchaserData.mobileNumber">
                <i class="fal fa-phone mr-2 text-muted"></i>
                <strong class="mr-2">Phone:</strong>
                <a [href]="'tel:' + dataItem.purchaserData.mobileNumber">{{ dataItem.purchaserData.mobileNumber }}</a>
              </div>
              <div *ngIf="!dataItem.purchaserData.email && !dataItem.purchaserData.mobileNumber" class="text-muted">
                <em>No information available</em>
              </div>
            </div>
          </div>
          <div class="col-2">
            <h6 class="font-weight-bold mb-3">Recipient Details</h6>
            <div class="mb-2" *ngIf="dataItem.recipientData">
              <div class="d-flex align-items-center mb-2">
                <i class="fal fa-user mr-2 text-muted"></i>
                <strong class="mr-2">Name:</strong>
                <span>{{ dataItem.recipientData.fullName }}</span>
              </div>
              <div class="d-flex align-items-center mb-2" *ngIf="dataItem.recipientData.email">
                <i class="fal fa-envelope mr-2 text-muted"></i>
                <strong class="mr-2">Email:</strong>
                <a [href]="'mailto:' + dataItem.recipientData.email">{{ dataItem.recipientData.email }}</a>
              </div>
              <div class="d-flex align-items-center mb-2" *ngIf="dataItem.recipientData.mobileNumber">
                <i class="fal fa-phone mr-2 text-muted"></i>
                <strong class="mr-2">Phone:</strong>
                <a [href]="'tel:' + dataItem.recipientData.mobileNumber">{{ dataItem.recipientData.mobileNumber }}</a>
              </div>
              <div *ngIf="!dataItem.recipientData.email && !dataItem.recipientData.mobileNumber" class="text-muted">
                <em>No information available</em>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </kendo-grid>
</div>

<ng-template #cardLookup let-modal>
  <div class="modal-header border-0 p-0">
    <button
      type="button"
      class="btn white-font p-0 ml-auto mr-2"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <i class="fal fa-times"></i>
    </button>
  </div>
  <div class="container p-0 pb-3">
    <app-gift-card-lookup></app-gift-card-lookup>
  </div>
</ng-template>
